import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import { marked } from 'marked';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkdownRender',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
    text?: string
}



const html = ref('')

function doMark() {
    html.value = marked(props.text) as string
}
doMark()

const renderMd = _.throttle(doMark, 1000)

watch(() => props.text, (value) => {
    renderMd()
})

return { __sfc: true,props, html, doMark, renderMd }
}

})